module.exports = __webpack_public_path__ + "media/images/icons/twotone/trophy-da7b43e68f55ffdc505c0029e380f359.svg";